{
  "title": "Evard's Black Tentacles",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a piece of tentacle from a giant octopus or a giant squid)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Squirming, ebony tentacles fill a 20-foot square on ground that you can see within range. For the duration, these tentacles turn the ground in the area into difficult terrain.",
    "When a creature enters the affected area for the first time on a turn or starts its turn there, the creature must succeed on a Dexterity saving throw or take 3d6 bludgeoning damage and be restrained by the tentacles until the spell ends. A creature that starts its turn in the area and is already restrained by the tentacles takes 3d6 bludgeoning damage.",
    "A creature restrained by the tentacles can use its action to make a Strength or Dexterity check (its choice) against your spell save DC. On a success, it frees itself."
  ],
  "spellLists": ["wizard"]
}
